import { Controller, type Control } from "react-hook-form";
import { Checkbox } from "primereact/checkbox";
import { Panel } from "primereact/panel";
import { formStyles } from "@/components/forms/formStyles";
import type { BookableEventFormData } from "@/lib/event-schemas";

export function ConsentFields(props: { control: Control<BookableEventFormData> }) {
  return (
    <Panel header="Registration Settings">
      <div className="flex flex-column gap-2">
        <div className="flex align-items-center">
          <Controller
            control={props.control}
            name="requiresConsentForm"
            render={({ field }) => (
              <Checkbox
                inputId="requiresConsentForm"
                checked={Boolean(field.value)}
                onChange={(e) => field.onChange(Boolean(e.checked))}
              />
            )}
          />
          <label
            htmlFor="requiresConsentForm"
            className="ml-2"
            style={formStyles.label}
          >
            Requires consent form
          </label>
        </div>

        <div className="flex align-items-center">
          <Controller
            control={props.control}
            name="requiresPhotoConsent"
            render={({ field }) => (
              <Checkbox
                inputId="requiresPhotoConsent"
                checked={Boolean(field.value)}
                onChange={(e) => field.onChange(Boolean(e.checked))}
              />
            )}
          />
          <label
            htmlFor="requiresPhotoConsent"
            className="ml-2"
            style={formStyles.label}
          >
            Requires photo consent
          </label>
        </div>

        <div className="flex align-items-center">
          <Controller
            control={props.control}
            name="groupsEnabled"
            render={({ field }) => (
              <Checkbox
                inputId="groupsEnabled"
                checked={Boolean(field.value)}
                onChange={(e) => field.onChange(Boolean(e.checked))}
              />
            )}
          />
          <label
            htmlFor="groupsEnabled"
            className="ml-2"
            style={formStyles.label}
          >
            Enable participant groups
          </label>
        </div>
      </div>
    </Panel>
  );
}








